module.exports = __webpack_public_path__ + "static/img/manual-25.e8635f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-25.png
// module id = 5l5w
// module chunks = 4